module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai578-590227293cff56684bedcc27be484852.jpg";